import { Modal } from 'antd';
import { useState } from 'react';
import styled from 'styled-components';
import { Box, Colors, IcClose, Text } from 'basic-ui-lib';
import { SelectStore, EnterCode } from './components';
import { NewScreenModalProps } from './types';

const NewScreenModal = ({ open, onClose }: NewScreenModalProps) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedStoreId, setSelectedStoreId] = useState<string | null>(null);

  const handleClose = () => {
    setCurrentStep(1);
    setSelectedStoreId(null);
    onClose();
  };

  const handleContinueStep1 = (storeId: string) => {
    setSelectedStoreId(storeId);
    setCurrentStep(2);
  };

  const handleContinueStep2 = () => {
    handleClose();
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return <SelectStore onContinue={handleContinueStep1} />;
      case 2:
        return selectedStoreId ? <EnterCode storeId={selectedStoreId} onContinue={handleContinueStep2} /> : null;
      default:
        return null;
    }
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={null}
      closable={false}
      width={1000}
      centered
      destroyOnClose
      styles={{
        content: {
          padding: 0,
          borderRadius: 8,
        },
      }}
    >
      <ModalContent>
        <Header>
          <Box flex={1}>
            <Text title_h5 semibold color='neutral.text.5' center>
              New Screen
            </Text>
            <Text content_2 medium color='neutral.text.3' center style={{ marginTop: 4 }}>
              { currentStep === 1 ? 'Create a new display screen to show digital signage content, including images, videos, or live streams.' : 'Choose one of the options below to set up your screen.' }
            </Text>
          </Box>
          <CloseButton onClick={handleClose}>
            <IcClose width={20} height={20} fill={Colors.neutral.text[5]} />
          </CloseButton>
        </Header>

        <Content>{renderStepContent()}</Content>
      </ModalContent>
    </Modal>
  );
};

export default NewScreenModal;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 24px 24px 16px 24px;
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 24px;
  right: 24px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${Colors.neutral.bg[2]};
  }
`;

const Content = styled.div`
  padding: 0 24px 24px 24px;
`;
